import { h } from 'preact'

const DangerIcon = ({ size = 92 }: { size?: number }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="none" viewBox="0 0 92 92">
    <path
      fill="#FF7676"
      d="M48.567 9.145a2.96 2.96 0 00-4.039-1.082 2.96 2.96 0 00-1.082 1.082L.406 83.73a2.895 2.895 0 000 2.957 2.957 2.957 0 002.56 1.48h86.08A2.962 2.962 0 0092 85.209a3.188 3.188 0 00-.493-1.676L48.567 9.145zM8.089 82.252l37.923-65.713 37.912 65.713H8.089z"
    />
    <path
      fill="#FF7676"
      d="M43.002 36.898v22.677a2.96 2.96 0 002.954 2.958 2.954 2.954 0 002.955-2.958V36.898a2.96 2.96 0 00-2.955-2.958 2.954 2.954 0 00-2.955 2.958zM45.95 66.476a2.962 2.962 0 00-2.954 2.957v1.971a2.96 2.96 0 002.955 2.958 2.953 2.953 0 002.955-2.958v-1.971a2.968 2.968 0 00-2.956-2.957z"
    />
  </svg>
)

export default DangerIcon
